import { Routes } from '@angular/router';
import { FaleConoscoPageComponent } from './pages/fale-conosco-page/fale-conosco-page.component';
import { InicioPageComponent } from './pages/inicio-page/inicio-page.component';
import { ErroNaoEncontradoPageComponent } from './pages/erro-nao-encontrado-page/erro-nao-encontrado-page.component';
import { PerguntasFrequentesPageComponent } from './pages/perguntas-frequentes-page/perguntas-frequentes-page.component';
import { ComunicadosPageComponent } from './pages/comunicados-page/comunicados-page.component';
import { AcessibilidadePageComponent } from './pages/acessibilidade-page/acessibilidade-page.component';
import { EdicaoJornalDoDiaPageComponent } from './pages/edicao-jornal-do-dia-page/edicao-jornal-do-dia-page.component';
import { GlossarioPageComponent } from './pages/glossario-page/glossario-page.component';
import { ServicosPageComponent } from './pages/servicos-page/servicos-page.component';
import { AutenticidadePageComponent } from './pages/autenticidade-page/autenticidade-page.component';
import { CalendarioPublicacoesPageComponent } from './pages/calendario-publicacoes-page/calendario-publicacoes-page.component';
import { PesquisaJornalPageComponent } from './pages/pesquisa-jornal-page/pesquisa-jornal-page.component';
import { HistoriaDoJornalPageComponent } from './pages/historia-do-jornal-page/historia-do-jornal-page.component';
import { ReportagensIconicasComponent } from './pages/reportagens-iconicas/reportagens-iconicas.component';

export enum SegovPage {
  Default = "",
  Inicio = "inicio",
  Sobre = "sobre",
  Servicos = "servicos",
  Atendimento = "atendimento",
  Glossario = "glossario",
  PerguntasFrequentes = "perguntas-frequentes",
  Comunicados = "comunicados",
  Acessibilidade = "acessibilidade",
  EdicaoDoDia = "edicao-do-dia",
  Autenticidade = "autenticidade",
  CalendarioPublicacao = "calendario-publicacao",
  PesquisaJornal = "pesquisa",
  HistoriaJornal = "historia-do-jornal",
  ReportagensIconicas = "reportagens-iconicas"
}

export const routes: Routes = [
  {
    path: SegovPage.Default,
    component: InicioPageComponent
  },
  {
    path: SegovPage.Inicio,
    component: InicioPageComponent
  },
  {
    path: SegovPage.Atendimento,
    component: FaleConoscoPageComponent
  },
  {
    path: SegovPage.Glossario,
    component: GlossarioPageComponent
  },
  {
    path: SegovPage.PerguntasFrequentes,
    component: PerguntasFrequentesPageComponent
  },
  {
    path: SegovPage.Comunicados,
    component: ComunicadosPageComponent
  },
  {
    path: SegovPage.Acessibilidade,
    component: AcessibilidadePageComponent
  },
  {
    path: SegovPage.EdicaoDoDia,
    component: EdicaoJornalDoDiaPageComponent
  },
  {
    path: SegovPage.Servicos,
    component: ServicosPageComponent
  },
  {
    path: SegovPage.Autenticidade,
    component: AutenticidadePageComponent},
  {
    path: SegovPage.CalendarioPublicacao,
    component: CalendarioPublicacoesPageComponent
  },
  {
    path: SegovPage.PesquisaJornal,
    component: PesquisaJornalPageComponent
  },
  {
    path: SegovPage.HistoriaJornal,
    component: HistoriaDoJornalPageComponent
  },
  {
    path: SegovPage.ReportagensIconicas,
    component: ReportagensIconicasComponent
  },

  // Erro 404
  {
    path: '**',
    pathMatch: 'full',
    component: ErroNaoEncontradoPageComponent
  }
];
